import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'ABOUT', path: '/about' },
    { name: 'BOOKS', path: '/books' },
    { name: 'BLOG', path: '/blog' },
    { name: 'GALLERY', path: '/gallery' },
    { name: 'CONTACT', path: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;
  const isHomePage = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/db323c45-fd61-4198-9a64-61097a4f03c4.png"
              alt="Edward J. Dumke"
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm tracking-widest uppercase transition-colors ${
                location.pathname === '/' && !isScrolled
                  ? 'text-white hover:text-[#C9A961]'
                  : 'text-[#8B2635] hover:text-[#6d1e29]'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`text-sm tracking-widest uppercase transition-colors ${
                location.pathname === '/' && !isScrolled
                  ? 'text-white hover:text-[#C9A961]'
                  : 'text-[#8B2635] hover:text-[#6d1e29]'
              }`}
            >
              About
            </Link>
            <Link
              to="/books"
              className={`text-sm tracking-widest uppercase transition-colors ${
                location.pathname === '/' && !isScrolled
                  ? 'text-white hover:text-[#C9A961]'
                  : 'text-[#8B2635] hover:text-[#6d1e29]'
              }`}
            >
              Books
            </Link>
            <Link
              to="/blog"
              className={`text-sm tracking-widest uppercase transition-colors ${
                location.pathname === '/' && !isScrolled
                  ? 'text-white hover:text-[#C9A961]'
                  : 'text-[#8B2635] hover:text-[#6d1e29]'
              }`}
            >
              Blog
            </Link>
            <Link
              to="/gallery"
              className={`text-sm tracking-widest uppercase transition-colors ${
                location.pathname === '/' && !isScrolled
                  ? 'text-white hover:text-[#C9A961]'
                  : 'text-[#8B2635] hover:text-[#6d1e29]'
              }`}
            >
              Gallery
            </Link>
            <Link
              to="/contact"
              className={`text-sm tracking-widest uppercase transition-colors ${
                location.pathname === '/' && !isScrolled
                  ? 'text-white hover:text-[#C9A961]'
                  : 'text-[#8B2635] hover:text-[#6d1e29]'
              }`}
            >
              Contact
            </Link>
          </div>

          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i
              className={`${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              } text-2xl ${isHomePage && !isScrolled ? 'text-white' : 'text-[#8B2635]'}`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-4">
            <Link
              to="/"
              className="block px-4 py-3 text-[#8B2635] hover:bg-[#F8F6F3] transition-colors text-sm tracking-widest uppercase"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block px-4 py-3 text-[#8B2635] hover:bg-[#F8F6F3] transition-colors text-sm tracking-widest uppercase"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/books"
              className="block px-4 py-3 text-[#8B2635] hover:bg-[#F8F6F3] transition-colors text-sm tracking-widest uppercase"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Books
            </Link>
            <Link
              to="/blog"
              className="block px-4 py-3 text-[#8B2635] hover:bg-[#F8F6F3] transition-colors text-sm tracking-widest uppercase"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Blog
            </Link>
            <Link
              to="/gallery"
              className="block px-4 py-3 text-[#8B2635] hover:bg-[#F8F6F3] transition-colors text-sm tracking-widest uppercase"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Gallery
            </Link>
            <Link
              to="/contact"
              className="block px-4 py-3 text-[#8B2635] hover:bg-[#F8F6F3] transition-colors text-sm tracking-widest uppercase"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contact
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;